
import { Note } from '@/types/lead';
import { supabase } from '@/integrations/supabase/client';
import { v4 as uuidv4 } from 'uuid';

// PERFORMANCE: Removed unnecessary imports and local storage fallbacks

// Add a note to a lead
export const addNote = async (leadId: string, content: string, tags?: string[]): Promise<Note> => {
  try {
    const userData = await supabase.auth.getUser();
    const userId = userData.data.user?.id;
    
    const newNote = {
      content,
      lead_id: leadId,
      created_by: userId,
      tags: tags || [],
    };
    
    // Insert into Supabase
    const { data, error } = await supabase
      .from('notes')
      .insert(newNote as any)
      .select()
      .single();

    if (error) throw error;
    
    // Return the formatted note
    return {
      id: data?.id || '',
      content: data?.content || '',
      createdAt: data?.created_at || '',
      updatedAt: data?.updated_at || '',
      tags: data?.tags || [],
    };
  } catch (error) {
    console.error('Error adding note to Supabase:', error);
    throw error;
  }
};

// Update a note
export const updateNote = async (noteId: string, updates: { content: string; tags: string[] }): Promise<Note> => {
  try {
    const { data, error } = await supabase
      .from('notes')
      .update({
        content: updates.content,
        tags: updates.tags,
      })
      .eq('id', noteId)
      .select()
      .single();

    if (error) throw error;

    return {
      id: data?.id || '',
      content: data?.content || '',
      createdAt: data?.created_at || '',
      updatedAt: data?.updated_at || '',
      tags: data?.tags || [],
    };
  } catch (error) {
    console.error('Error updating note:', error);
    throw error;
  }
};

// Delete a note
export const deleteNote = async (leadId: string, noteId: string): Promise<void> => {
  try {
    // Delete from Supabase
    const { error } = await supabase
      .from('notes')
      .delete()
      .eq('id', noteId);

    if (error) throw error;
  } catch (error) {
    console.error('Error deleting note:', error);
    throw error;
  }
};

// Get company's note tags
export const getCompanyNoteTags = async (companyId: string): Promise<string[]> => {
  try {
    const { data, error } = await supabase
      .rpc('get_company_note_tags', { company_id: companyId });

    if (error) throw error;

    return (data || []).map(row => row.tag);
  } catch (error) {
    console.error('Error fetching company note tags:', error);
    return [];
  }
};
